module.exports = __webpack_public_path__ + "static/media/onboarding6.58dd7b26.svg";